import $http from '../../../axios-instance';

export async function generarEtiqueta({ commit, state, rootState }) {
  commit('dashboard/load', true, {root: true})

    var producto = rootState.productos_et.selectedProductEt.id;


    await $http.post(`adm_productos/etiqueta/${producto}`, state.pdfet)
        .then((response) => {
          
            window.open(process.env.VUE_APP_API_URL + response.data)
            state.error = false
        })
        .catch((error) => {
            commit('etiquetaError', error.message)
        })
  commit('dashboard/load', false, {root: true})
}
